export const LINE_ITEM_SWIPE_EVENT = 'cart:lineitem-swipe-open';

export function emitLineItemSwipeOpen(lineRef: string | null) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(LINE_ITEM_SWIPE_EVENT, { detail: { lineRef } }));
}
